import { composeIO } from 'react-compose-io'
import { pedidosDivergentesResumoIO } from './PedidosDivergentesResumo.IO'
import { PedidosDivergentesResumoView } from './PedidosDivergentesResumo.View'

export const PedidosDivergentesResumo = composeIO(PedidosDivergentesResumoView, pedidosDivergentesResumoIO)
